import React from 'react'
import { useEffect, useState } from 'react'
import { STags, SDrawerOrModal } from 'shj-components'
import { useNavigate, useParams } from 'react-router-dom'
import { listProductSkuRelationSpuFormat } from '@/services/order'
import { Tag, Checkbox, Row, Col, Select, Input, Button, Card, Flex, Tooltip } from 'antd'
import defaultImg from '@/assets/errImg.png'
import {
  CloseCircleOutlined,
  DownOutlined,
  CheckOutlined,
  QuestionCircleOutlined,
  DoubleRightOutlined,
} from '@ant-design/icons'
import styles from '../../index.module.less'
import { cloneDeep, isEmpty } from 'lodash-es'
import KitDetailDialogV3 from '@/pages/orderService/components/KitDetailDialogV3'
import SkuDynamic from '@/pages/orderService/components/SkuDynamic'
import ModifyStandard from '@/pages/orderService/components/modifyStandard'

const { TextArea } = Input

const materialTypeTagStrMap: any = {
  GENERAL: '标配',
  PROJECT: '标配',
  ADD: '增项',
  SUB: '减项',
  UP_DOWN: '升降级',
  ACTIVITY: '优惠',
}
const materialTypeTagBgMap: any = {
  GENERAL: 'rgba(0, 168, 101, 1)',
  PROJECT: 'rgba(227, 238, 255, 1)',
  ADD: 'rgba(235, 55, 35, 1)',
  SUB: 'rgba(136, 81, 237, 1)',
  UP_DOWN: 'rgba(245, 147, 0, 1)',
  ACTIVITY: 'rgba(242, 90, 10, 1)',
}
const materialTypeTagColorMap: any = {
  GENERAL: '#fff',
  PROJECT: '#fff',
  ADD: '#fff',
  SUB: '#fff',
  UP_DOWN: '#fff',
  ACTIVITY: '#fff',
}

export default function MaterialCar({
  data = [],
  spaceAllList = [],
  setData = a => ({}),
  currentSearchParams = {},
  type = '',
  setSelectedSpuInfo = a => ({}),
  setShowDetailModal = a => ({}),
  setModalTile = a => ({}),
}) {
  const params = useParams()
  const budgetId = params.budgetId //报价id
  // 套件选择
  const [kitSku, setKitSku] = useState<Array<any>>({})
  const [kitSpu, setKitSpu] = useState<Array<any>>({})
  const [openKitDialog, setOpenKitDialog] = useState(false)
  const [combinationInfoList, setCombinationInfoList] = useState<any[]>([])
  const [activityInfo, setActivityInfo] = useState<any>({})
  const [recordItem, setRecordItem] = useState<Array<any>>({})
  // 商品规格
  const [skuList, setSkuList] = useState<any>([]) // 当前产品的sku map信息
  const [modifyLoading, setModifyLoading] = useState<boolean>(false) // 修改规格loading
  const [currentIndex, setCurrentIndex] = useState<number>(0) // 当前修改规格数组索引
  const [currentModifyStandardArray, setCurrentModifyStandardArray] = useState<any>([]) // 当前修改规格数组
  const [modifyStandardOpen, setModifyStandardOpen] = useState(false) // 修改规格
  // 动态属性
  const [skuDynamicOpen, setSkuDynamicOpen] = useState(false) // 动态属性弹窗
  const [skuDynamicVoList, setSkuDynamicVoList] = useState<any>([]) // 报价属性表单数据

  const onChangeSpaceAll = (e: any, item: any) => {
    let newData = cloneDeep(data)
    item.checked = e.target.checked
    // 全选，应用全局
    newData.map((elItem: any) => {
      if (elItem.rightMenuCode === 'PROJECT') {
        return
      }
      // 实现空间全部应用 全选和全不选 即 全选的 空间只影响 该空间的勾选与否  不影响其他单独配的空间
      if (e.target.checked) {
        if (elItem.budgetItemList?.find((el: any) => el.id === item.id)) {
          elItem.spaceChecked.push(item.id)
          elItem.spaceChecked = Array.from(new Set(elItem.spaceChecked))
        }
      } else {
        elItem.spaceChecked = elItem.spaceChecked?.filter((el: any) => el !== item.id)
      }
    })
    setData(newData)
  }

  const singleMaterialCheck = (e: any, index: any) => {
    console.log(index)
    let newData = cloneDeep(data)
    newData[index].checked = e.target.checked
    /*const hasCheckedList = newData.filter(data => data.checked);
    if (!hasCheckedList?.length) {
      setAllSelect(false);
    }*/
    setData(newData)
  }

  const handleOpenKitDialog = async (record: any, index) => {
    setKitSku(record.productSku)
    setKitSpu(record.productSpu)
    setCurrentIndex(index)
    setRecordItem(record)
    // 二次点开回显
    console.log(record, 'record')
    if (record.rightMenuCode === 'ACTIVITY') {
      setActivityInfo({
        activityId: record.activity?.id,
        activityProductId: record.activityProduct?.id,
      })
    }
    if (record.packDtlList?.length) {
      setCombinationInfoList(record.packDtlList)
    } else {
      setCombinationInfoList([])
    }
    setOpenKitDialog(true)
  }

  const handleOpenSpecsDialog = async (record: any, index?: any) => {
    console.log(record, index)
    setModifyStandardOpen(true)
    setModifyLoading(true)
    setCurrentIndex(index)
    let dynaOptions
    let resData
    try {
      resData = await listProductSkuRelationSpuFormat({
        data: {
          quoteBudgetId: budgetId,
          productSpuId: record.productSpuId,
          generalId:
            record.rightMenuCode === 'UP_DOWN' || record.rightMenuCode === 'GENERAL'
              ? record.generalId || null
              : null,
          priceCalcType: record.rightMenuCode === 'UP_DOWN' ? 'CHANGE_LEVEL' : null,
          activityProductId: record?.activityProduct?.id || null,
        },
      })
    } catch {
      setModifyLoading(false)
    }
    setModifyLoading(false)
    dynaOptions = record.dynaOptions
    setSkuList(resData.skuList)
    resData.specificationArgList?.map((item: any) => {
      if (!isEmpty(dynaOptions)) {
        item.argValId = dynaOptions[item.argCode].valueId
        item.argValName = dynaOptions[item.argCode].valueName
      }
      item.options = item?.values.map((ol: any) => {
        return {
          ...ol,
          argValId: ol.valueId,
          argValName: ol.valueName,
        }
      })
      return item
    })
    setCurrentModifyStandardArray(resData.specificationArgList || [])
  }

  const handleOpenAttrDialog = (record: any, index?: any) => {
    setSkuDynamicOpen(true)
    // setModifyLoading(true)
    setCurrentIndex(index)
    setSkuDynamicVoList(record.skuDynamicVoList)
  }

  const deleteSpace = (record: any, index: any) => {
    const array = cloneDeep(data)
    array.splice(index, 1)
    setData(array)
  }
  const getVal = (val)=>{
     let funcRes: any = ''
    try {
      const func = new Function(`return ${val}`)
      funcRes = func()
    } catch (err) {
      funcRes = false
    }
    return funcRes
  }
  const onChangeSpace = (checkedValues: string[], index?: any) => {
    let newData = cloneDeep(data)
    newData[index].spaceChecked = checkedValues
    const spaceList = newData[index]?.budgetItemList
      ?.filter((item: any) => checkedValues.includes(item.id))
      ?.filter((item: any) => item.displayQtyFormular)
    newData[index].spaceDetailInfoList = spaceList?.map((item: any) => ({
      elTag: item.id,
      calculate: item.displayQtyFormular,
      calculateFunc: getVal(item.displayQtyFormular)
    }))
    setData(newData)
  }

  const collapseSpace = (index: number) => {
    const newData = cloneDeep(data)
    newData[index].collapseSpace = true
    setData(newData)
  }

  const expandSpace = (index: number) => {
    const newData = cloneDeep(data)
    newData[index].collapseSpace = false
    setData(newData)
  }

  const changeCalculate = (elTag: string, val: string, index: number) => {
    const newData = cloneDeep(data) || []
    let funcRes: any = ''
    try {
      const func = new Function(`return ${val}`)
      funcRes = func()
    } catch (err) {
      funcRes = false
    }
    if (newData[index].spaceDetailInfoList) {
      const obj = newData[index].spaceDetailInfoList?.find(item => item.elTag === elTag)
      if (obj) {
        obj.calculate = val
        obj.calculateFunc = funcRes
      } else {
        newData[index].spaceDetailInfoList.push({
          elTag,
          calculate: val,
          calculateFunc: funcRes,
        })
      }
    } else {
      newData[index].spaceDetailInfoList = [
        {
          elTag,
          calculate: val,
          calculateFunc: funcRes,
        },
      ]
    }
    setData(newData)
  }

  const changeRemark = (elTag: string, val: string, index: number) => {
    const newData = cloneDeep(data) || []
    if (newData[index].spaceDetailInfoList) {
      const obj = newData[index].spaceDetailInfoList?.find(item => item.elTag === elTag)
      if (obj) {
        obj.remark = val
      } else {
        newData[index].spaceDetailInfoList.push({
          elTag,
          remark: val,
        })
      }
    } else {
      newData[index].spaceDetailInfoList = [
        {
          elTag,
          remark: val,
        },
      ]
    }
    setData(newData)
  }

  const closeKitDialog = (value: any) => {
    setOpenKitDialog(false)
  }
 const handleLongDesc = data => {
    // 子产品有且只有一个为来源物料 工艺说明为该子产品的sku的工艺说明
    let materialList = data?.filter(
      (item: any) => item?.product?.sourceType === 'MATERIAL' && item?.checked
    )
    if (materialList.length === 1) {
      let skuInfo = materialList[0]?.skuList?.find(
        (el: any) => el.id === materialList[0]?.selectSkuId
      )
      return skuInfo?.longDesc
    } else {
      return ''
    }
  }
  const confirmInfo = (combinationInfoDetail: any, combinationPrice) => {
    console.log(currentIndex)
    let longDesc = ''
    if (combinationInfoDetail && combinationInfoDetail.length) {
      longDesc = handleLongDesc(combinationInfoDetail)
    }
    const newData = cloneDeep(data)
    newData[currentIndex].packDtlList = combinationInfoDetail
    newData[currentIndex].productSkuSalePrice =
      combinationPrice || combinationPrice === 0
        ? combinationPrice
        : newData[currentIndex].productSkuSalePrice
    newData[currentIndex].longDesc = longDesc

    setData(newData)
  }

  const onSubmitModifyStandard = async value => {
    console.log(value, currentIndex)
    let selectObj = {}
    let dynaOptions: any = {}
    let newSkuObj: any = {}
    value.forEach((item: any) => {
      selectObj[item.argCode] = {
        argValId: item.argValId,
        argValName: item.argValName,
      }
    })
    // 确定sku
    skuList.forEach((item: any) => {
      let flag = true
      for (let key in selectObj) {
        if (item.argMap[key].valueId !== selectObj[key].argValId) {
          flag = false
        }
      }
      if (flag) {
        newSkuObj = item
      }
    })
    // 选材之后确定SKU码
    const newData = cloneDeep(data)
    newData[currentIndex].dynaOptions = newSkuObj.argMap
    newData[currentIndex].productSkuName = newSkuObj.skuName
    newData[currentIndex].productSkuPrimaryImage = newSkuObj?.mainPicUrl
    newData[currentIndex].productSkuSalePrice = newSkuObj.priceInfo?.customerPrice
    newData[currentIndex].productSkuId = newSkuObj.id
    newData[currentIndex].productSku = newSkuObj
    newData[currentIndex].longDesc = newSkuObj?.longDesc

    setData(newData)
  }

  const onSubmitSkuDynamicVoList = async value => {
    const newData = cloneDeep(data)
    newData[currentIndex].materialDynaOptions = value
    setData(newData)
  }

    const handlePrice = (item: any) => {
    let value =
      item.combinationPrice ??
      item.productSkuSalePrice ??
      item.saleCustPrice

    return value || value === 0 ? '￥' + value : ''
  }

  return (
    <div className={styles.baseBox}>
      <Row align="middle" justify="space-between">
        <Col span={20}>
          {spaceAllList?.length ? (
            <span className={styles.garyFontColor} style={{ margin: '0px 10px 0 5px ' }}>
              空间全选：
            </span>
          ) : null}
        </Col>
      </Row>
      <Flex style={{ marginBottom: '10px' }} wrap>
        {spaceAllList.map((item: any, index: number) => {
          return (
            <div
              className={styles.checkboxOutLook}
              key={'space' + index}
              style={{
                borderColor: item.checked ? 'var(--theme-color)' : 'rgba(190, 191, 194, 1)',
              }}
            >
              <Checkbox
                disabled={data.length === 0}
                key={item.id}
                checked={item.checked}
                onChange={(e: any) => onChangeSpaceAll(e, item)}
              >
                {item.showName}
              </Checkbox>
            </div>
          )
        })}
      </Flex>
      {/* 单个空间选择 */}
      {data &&
        data.map((item: any, index: any) => {
          return (
            <div
              style={{ padding: '15px 15px 5px 10px' }}
              key={index}
              className={`${styles.spaceBox}  ${item.checked ? styles.checkedBox : ''}`}
            >
              <Row className={styles.spaceRow}>
                <div style={{ display: 'flex' }}>
                  <Checkbox
                    disabled={item.errMessage || item.disabled}
                    checked={item.checked}
                    defaultChecked={item.checked}
                    onChange={e => {
                      singleMaterialCheck(e, index)
                    }}
                  ></Checkbox>
                </div>
                <Col span={18} style={{ display: 'flex' }}>
                  {item.listDtl && <div className={styles.colTitle}>已选套件</div>}
                  <div className={styles.choosedImg}>
                    {item.disabled ? (
                      <div className={styles.choosedImgDisabled}>产品已下架失效</div>
                    ) : null}
                    <img
                      className={styles.imgStyle}
                      src={
                        item.productSkuPrimaryImage
                          ? item.productSkuPrimaryImage
                          : item?.productSku?.mainPicUrl || defaultImg
                      }
                      // onClick={() => {
                      //   setSelectedSpuInfo(item.productSku)
                      //   setModalTile('SKU信息')
                      //   setShowDetailModal(true)
                      // }}
                    />
                    {item.rightMenuCode !== 'PROJECT' ? (
                      <div className={styles.choosedTag}>
                        <STags
                          itemKey={
                            item.rightMenuCode === 'SUB'
                              ? item.referenceRefType === 'ACTIVITY'
                                ? item.referenceRefType
                                : item.rightMenuCode
                              : item.rightMenuCode
                          }
                        />
                      </div>
                    ) : null}
                  </div>
                  {/* 报错回显 */}
                  {item?.errMessage && (
                    <div
                      dangerouslySetInnerHTML={{ __html: item?.errMessage }}
                      className={styles.errMessageBox}
                    ></div>
                  )}
                  <div className={styles.colDesc}>
                    <div className={item.errMessage ? styles.disabledFontcolor : styles.skuDesc}>
                      {item.rightMenuCode !== 'SUB' ? item.productSkuName : item.referenceName}
                    </div>
                    <div className={item.errMessage ? styles.disabledFontcolor : ''}>
                    SKU: {item.productSkuId}
                    </div>
                    {(item?.longDesc || item?.productSpu?.longDesc) && (
                      <p className={styles.skuCard_longDesc}>
                        <span>工艺说明：</span>
                        <Tooltip
                          title={item?.longDesc || item?.productSpu?.longDesc}
                          placement="topLeft"
                        >
                          <span>{item?.longDesc || item?.productSpu?.longDesc}</span>
                        </Tooltip>
                      </p>
                    )}
                    <div className={styles.price}>
                      {/* {item.combinationPrice
                        ? `￥${item.combinationPrice}`
                        : item.productSkuSalePrice
                        ? `￥${item.productSkuSalePrice}`
                        : item.saleCustPrice
                        ? `￥${item.saleCustPrice}`
                        : null} */}
                        {handlePrice(item)}
                    </div>
                  </div>
                </Col>
                <Col flex={1} style={{ textAlign: 'right' }}>
                  {item.rightMenuCode !== 'SUB' &&
                    item.productSpu?.prodType === 'PRODUCT_GROUP' && (
                      <Button
                        disabled={item.errMessage}
                        color="primary"
                        variant="outlined"
                        size="small"
                        style={{ marginRight: '10px' }}
                        onClick={() => handleOpenKitDialog(item, index)}
                      >
                        产品明细
                      </Button>
                    )}
                  {item.rightMenuCode !== 'SUB' &&
                    item.productSpu?.prodType !== 'PRODUCT_GROUP' &&
                    item.productSpu?.skuList?.length > 1 && (
                      <Button
                        disabled={item.errMessage}
                        color="primary"
                        variant="outlined"
                        size="small"
                        style={{ marginRight: '10px' }}
                        onClick={() => handleOpenSpecsDialog(item, index)}
                      >
                        选择规格
                      </Button>
                    )}
                  {item.rightMenuCode !== 'SUB' && item.skuDynamicVoList?.length ? (
                    <Button
                      color="primary"
                      variant="outlined"
                      size="small"
                      style={{ marginRight: '10px' }}
                      onClick={() => handleOpenAttrDialog(item, index)}
                    >
                      报价属性
                    </Button>
                  ) : null}
                  <Button danger size="small" onClick={() => deleteSpace(item, index)}>
                    移除
                  </Button>
                </Col>
              </Row>
              <Row
                style={{
                  marginTop: '20px',
                  marginLeft: 26,
                  paddingBottom: data[index].collapseSpace ? '10px' : 0,
                }}
              >
                {data[index]?.budgetItemList?.length &&
                !data[index]?.budgetItemList?.[0]?.isRoot &&
                item.rightMenuCode !== 'PROJECT' ? (
                  <Col span={data[index].collapseSpace ? 4 : 7}>
                    {/* 空间配置 */}
                    <Button
                      style={{ border: '0px', paddingLeft: 0 }}
                      disabled={item.errMessage}
                      color="primary"
                      size="small"
                      className={styles.themeColor}
                    >
                      应用空间（
                      {data[index]?.spaceChecked?.length +
                        ' / ' +
                        (data[index]?.budgetItemList?.length || 0)}
                      ）
                      <DownOutlined />
                    </Button>
                    <Select
                      className={styles.hiddenSelect}
                      disabled={item.errMessage}
                      mode="multiple"
                      allowClear
                      size="small"
                      style={{
                        width: '100%',
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        opacity: '0',
                      }}
                      key={index}
                      showSearch={false}
                      fieldNames={{ label: 'showName', value: 'id' }}
                      value={data[index]?.spaceChecked}
                      onChange={value => onChangeSpace(value, index)}
                      options={data[index]?.budgetItemList}
                    />
                  </Col>
                ) : (
                  <>
                    {item.rightMenuCode === 'PROJECT' ? (
                      <Col span={data[index].collapseSpace ? 4 : 7}>
                        <Button
                          className={styles.themeColor}
                          style={{ border: '0px', paddingLeft: 0 }}
                          disabled={item.errMessage}
                          color="primary"
                          size="small"
                        >
                          项目
                        </Button>
                      </Col>
                    ) : null}
                  </>
                )}
                {((data[index].spaceChecked && data[index].spaceChecked.length !== 0) ||
                  item.rightMenuCode === 'PROJECT') && (
                  <>
                    {data[index].collapseSpace ? (
                      <>
                        {item.rightMenuCode !== 'PROJECT' ? (
                          <Col span={17} style={{ display: 'flex' }}>
                            {/* 已选择空间 */}
                            {data[index].spaceChecked &&
                              data[index].spaceChecked.map((elTag, elTagIndex) => {
                                return (
                                  <Tag
                                    key={elTag}
                                    className={styles.garyFontColor}
                                    closeIcon={item.errMessage ? '' : <CloseCircleOutlined />}
                                    style={{
                                      cursor: 'pointer',
                                      height: '100%',
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                    onClose={() => {
                                      const newData = cloneDeep(data)
                                      newData[index].spaceChecked = newData[
                                        index
                                      ].spaceChecked.filter(el => el != elTag)
                                      setData(newData)
                                    }}
                                  >
                                    {
                                      data[index]?.budgetItemList.find(el => el.id == elTag)
                                        .showName
                                    }
                                  </Tag>
                                )
                              })}
                          </Col>
                        ) : (
                          <Col span={17} style={{ display: 'flex' }}></Col>
                        )}
                      </>
                    ) : (
                      <>
                        {item.rightMenuCode !== 'rightNewStandard' && (
                          <Col
                            style={{ height: '24px', display: 'flex', alignItems: 'center' }}
                            span={6}
                          >
                            预算量计算式
                          </Col>
                        )}
                        <Col
                          style={{ height: '24px', display: 'flex', alignItems: 'center' }}
                          span={item.rightMenuCode !== 'rightNewStandard' ? 8 : 14}
                        >
                          备注
                        </Col>
                      </>
                    )}
                    {!data[index].collapseSpace ? (
                      <Col
                        onClick={() => collapseSpace(index)}
                        flex={'space-between'}
                        style={{
                          height: '24px',
                          color: 'var(--theme-color)',
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'center',
                          cursor: 'pointer',
                        }}
                        span={3}
                      >
                        收起
                        <DoubleRightOutlined
                          style={{ transform: 'rotate(-90deg)', marginLeft: 4 }}
                        />
                      </Col>
                    ) : (
                      <Col
                        onClick={() => expandSpace(index)}
                        flex={'space-between'}
                        style={{
                          height: '24px',
                          color: 'var(--theme-color)',
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'center',
                          cursor: 'pointer',
                        }}
                        span={3}
                      >
                        展开
                        <DoubleRightOutlined
                          style={{ transform: 'rotate(90deg)', marginLeft: 4 }}
                        />
                      </Col>
                    )}
                  </>
                )}
              </Row>
              {/* 已选择空间 */}
              {item.rightMenuCode !== 'PROJECT' && !data[index]?.budgetItemList?.[0]?.isRoot ? (
                <>
                  {!data[index]?.collapseSpace &&
                    data[index]?.spaceChecked &&
                    data[index]?.spaceChecked.map((elTag, elTagIndex) => {
                      return (
                        <Row
                          style={{ marginTop: 10, marginBottom: 10, marginLeft: 26 }}
                          key={'spaceDetail' + elTagIndex}
                        >
                          <Col
                            span={7}
                            style={{
                              lineHeight: '18px',
                              display: 'flex',
                              alignItems: 'center',
                              wordBreak: 'break-all',
                            }}
                          >
                            <CloseCircleOutlined
                              style={{ marginRight: 10 }}
                              onClick={() => {
                                const newData = cloneDeep(data)
                                newData[index].spaceChecked = newData[index]?.spaceChecked.filter(
                                  el => el != elTag
                                )
                                setData(newData)
                              }}
                            />
                            {data[index]?.budgetItemList.find(el => el.id == elTag).showName}
                          </Col>
                          {/**
                           * 预算量计算式
                           */}
                          {item.rightMenuCode !== 'rightNewStandard' && (
                            <Col span={6} style={{ display: 'flex', alignItems: 'center' }}>
                              <Input
                                disabled={
                                  data[index].generalId
                                    ? data[index].updateBudgetQtyFormularFlag
                                      ? false
                                      : true
                                    : false
                                }
                                value={
                                  data[index]?.spaceDetailInfoList?.find(el => el.elTag == elTag)
                                    ?.calculate || ''
                                }
                                onChange={e => changeCalculate(elTag, e?.target?.value, index)}
                                style={{ width: '65%' }}
                              ></Input>
                              {typeof data[index]?.spaceDetailInfoList?.find(
                                el => el.elTag == elTag
                              )?.calculateFunc === 'number' ? (
                                <span style={{ marginLeft: 4 }}>
                                  {
                                    data[index]?.spaceDetailInfoList?.find(el => el.elTag == elTag)
                                      ?.calculateFunc
                                  }
                                </span>
                              ) : data[index]?.spaceDetailInfoList?.find(el => el.elTag == elTag)
                                  ?.calculateFunc === false ? (
                                <span style={{ marginLeft: 4, color: 'red' }}>!</span>
                              ) : null}
                            </Col>
                          )}
                          {/**
                           * 备注
                           */}
                          <Col span={11} style={{ display: 'flex', alignItems: 'center' }}>
                            <TextArea
                              value={
                                data[index]?.spaceDetailInfoList?.find(el => el.elTag == elTag)
                                  ?.remark || ''
                              }
                              onChange={e => changeRemark(elTag, e?.target?.value, index)}
                              placeholder="请输入备注"
                              autoSize={{ minRows: 1, maxRows: 3 }}
                              maxLength={300}
                            />
                          </Col>
                        </Row>
                      )
                    })}
                </>
              ) : item.rightMenuCode === 'PROJECT' ? (
                <>
                  {!data[index].collapseSpace ? (
                    <Row
                      style={{ marginTop: 10, marginBottom: 10, marginLeft: 26 }}
                      key={'spaceDetail' + item.quoteBudgetItemId}
                    >
                      <Col
                        span={7}
                        style={{
                          lineHeight: '18px',
                          display: 'flex',
                          alignItems: 'center',
                          wordBreak: 'break-all',
                        }}
                      >
                        {item.quoteBudgetItemName}
                      </Col>
                      {/**
                       * 预算量计算式
                       */}
                      {item.rightMenuCode !== 'rightNewStandard' && (
                        <Col span={6} style={{ display: 'flex', alignItems: 'center' }}>
                          <Input
                            disabled={
                              data[index].generalId
                                ? data[index].updateBudgetQtyFormularFlag
                                  ? false
                                  : true
                                : false
                            }
                            value={
                              data[index]?.spaceDetailInfoList?.find(
                                el => el.elTag == item.quoteBudgetItemId
                              )?.calculate || ''
                            }
                            onChange={e =>
                              changeCalculate(item.quoteBudgetItemId, e?.target?.value, index)
                            }
                            style={{ width: '65%' }}
                          ></Input>
                          {typeof data[index]?.spaceDetailInfoList?.find(
                            el => el.elTag == item.quoteBudgetItemId
                          )?.calculateFunc === 'number' ? (
                            <span style={{ marginLeft: 4 }}>
                              {
                                data[index]?.spaceDetailInfoList?.find(
                                  el => el.elTag == item.quoteBudgetItemId
                                )?.calculateFunc
                              }
                            </span>
                          ) : data[index]?.spaceDetailInfoList?.find(
                              el => el.elTag == item.quoteBudgetItemId
                            )?.calculateFunc === false ? (
                            <span style={{ marginLeft: 4, color: 'red' }}>!</span>
                          ) : null}
                        </Col>
                      )}
                      {/**
                       * 备注
                       */}
                      <Col span={11} style={{ display: 'flex', alignItems: 'center' }}>
                        <TextArea
                          value={
                            data[index]?.spaceDetailInfoList?.find(
                              el => el.elTag == item.quoteBudgetItemId
                            )?.remark || ''
                          }
                          onChange={e =>
                            changeRemark(item.quoteBudgetItemId, e?.target?.value, index)
                          }
                          placeholder="请输入备注"
                          autoSize={{ minRows: 1, maxRows: 3 }}
                          maxLength={300}
                        />
                      </Col>
                    </Row>
                  ) : null}
                </>
              ) : !data[index]?.budgetItemList?.[0]?.isRoot ? (
                <>
                  {!data[index].collapseSpace ? (
                    <Row
                      style={{ marginTop: 10, marginBottom: 10, marginLeft: 26 }}
                      key={'spaceDetail' + data[index]?.budgetItemList?.[0]?.id}
                    >
                      {/**
                       * 预算量计算式
                       */}
                      {item.rightMenuCode !== 'rightNewStandard' && (
                        <Col span={6} style={{ display: 'flex', alignItems: 'center' }}>
                          <Input
                            disabled={
                              data[index].generalId
                                ? data[index].updateBudgetQtyFormularFlag
                                  ? false
                                  : true
                                : false
                            }
                            value={
                              data[index]?.spaceDetailInfoList?.find(
                                el => el.elTag == data[index]?.budgetItemList?.[0]?.id
                              )?.calculate || ''
                            }
                            onChange={e =>
                              changeCalculate(
                                data[index]?.budgetItemList?.[0]?.id,
                                e?.target?.value,
                                index
                              )
                            }
                            style={{ width: '65%' }}
                          ></Input>
                          {typeof data[index]?.spaceDetailInfoList?.find(
                            el => el.elTag == data[index]?.budgetItemList?.[0]?.id
                          )?.calculateFunc === 'number' ? (
                            <span style={{ marginLeft: 4 }}>
                              {
                                data[index]?.spaceDetailInfoList?.find(
                                  el => el.elTag == data[index]?.budgetItemList?.[0]?.id
                                )?.calculateFunc
                              }
                            </span>
                          ) : data[index]?.spaceDetailInfoList?.find(
                              el => el.elTag == data[index]?.budgetItemList?.[0]?.id
                            )?.calculateFunc === false ? (
                            <span style={{ marginLeft: 4, color: 'red' }}>!</span>
                          ) : null}
                        </Col>
                      )}
                      {/**
                       * 备注
                       */}
                      <Col span={11} style={{ display: 'flex', alignItems: 'center' }}>
                        <TextArea
                          value={
                            data[index]?.spaceDetailInfoList?.find(
                              el => el.elTag == data[index]?.budgetItemList?.[0]?.id
                            )?.remark || ''
                          }
                          onChange={e =>
                            changeRemark(
                              data[index]?.budgetItemList?.[0]?.id,
                              e?.target?.value,
                              index
                            )
                          }
                          placeholder="请输入备注"
                          autoSize={{ minRows: 1, maxRows: 3 }}
                          maxLength={300}
                        />
                      </Col>
                    </Row>
                  ) : null}
                </>
              ) : null}
            </div>
          )
        })}
      {/* 产品明细 */}
      {openKitDialog && (
        <KitDetailDialogV3
          kitSku={kitSku}
          setKitSku={setKitSku}
          productInfo={kitSpu}
          open={openKitDialog}
          closeDialog={closeKitDialog}
          confirmInfo={confirmInfo}
          combinationInfoList={combinationInfoList}
          activityInfo={activityInfo}
          generalId={recordItem?.generalId}
        />
      )}

      {/* 修改规格 */}
      <ModifyStandard
        open={modifyStandardOpen}
        onCancel={() => {
          setModifyStandardOpen(false)
        }}
        skuList={skuList}
        loading={modifyLoading}
        formList={currentModifyStandardArray}
        title="选择规格"
        onSubmit={onSubmitModifyStandard}
      ></ModifyStandard>
      {/* 动态属性 */}
      <SkuDynamic
        open={skuDynamicOpen}
        onCancel={() => {
          setSkuDynamicOpen(false)
        }}
        loading={false}
        formList={skuDynamicVoList}
        title="报价属性"
        onSubmit={onSubmitSkuDynamicVoList}
      ></SkuDynamic>
    </div>
  )
}
